import './accepted-cards.png';
import './accepted-cards@2x.png';
import './american-express.png';
import './american-express@2x.png';
import './download-large.png';
import './download-large@2x.png';
import './download-small.png';
import './download-small@2x.png';
import './envelope.svg';
import './fallacies_poster.png';
import './hero.svg';
import './mastercard.png';
import './mastercard@2x.png';
import './or-text.png';
import './or-text@2x.png';
import './paypal-logo.png';
import './paypal-logo@2x.png';
import './paypal.png';
import './paypal.svg';
import './paypal@2x.png';
import './pdf.png';
import './pdf@2x.png';
import './poster.png';
import './schoolofthought_small.jpg';
import './ship-large.png';
import './ship-large@2x.png';
import './visa.png';
import './visa@2x.png';
import './your-logical-fallacy-is-com.png';
import './your-logical-fallacy-is-com@2x.png';
import './your-logical-fallacy-is.png';
import './your-logical-fallacy-is@2x.png';



// WEBPACK FOOTER //
// ./resources/assets/images/index.js